import { call, put, race, select, take } from 'redux-saga/effects';
import {
  ABOVE_THE_FOLD_OPTIMIZATION_LOCATION_NAME,
  DEFAULT_OPTIMIZATION_LOCATION_NAME,
} from '@nike/ciclp-config';
import { applyPatch } from '@nike/ciclp-utils/patches';
import logger from '@nike/ciclp-utils/logger';
import { HYDRATE } from 'next-redux-wrapper';
import { optimizationActions, privacyActions } from '../../actions';
import {
  canonicalUrlSelector,
  countryCodeSelector,
  languageCodeSelector,
  pageIdSelector,
} from '../../store/state/stateSelector';
import {
  canPersonalizeSelector,
  isPrivacySet as isPrivacySetSelector,
} from '../../store/state/privacy/privacySelector';
import { getOptimizationLocations } from './getOptimizationLocations';

export const hasUserAllowedPersonalization = function* () {
  const isPrivacySet = yield select(isPrivacySetSelector);
  if (!isPrivacySet) {
    yield race({
      nikePrivacy: take(privacyActions.setNikePrivacy.type),
      sqPrivacy: take(privacyActions.set.type),
    });
  }
  return yield select(canPersonalizeSelector);
};

export const saveAnalyticsFromATCookie = function* (atCookie) {
  const { tnta } = atCookie;
  const cookieLocations = [
    {
      analytics: tnta,
    },
  ];

  yield put(optimizationActions.loadLocations(cookieLocations));
};

export const getAboveTheFoldOptimizationLocations = function* () {
  const pageUrl = yield select(canonicalUrlSelector);

  return yield call(
    getOptimizationLocations,
    ABOVE_THE_FOLD_OPTIMIZATION_LOCATION_NAME,
    {
      appPageUrl: pageUrl,
    },
  );
};

export const getDefaultOptimizationLocations = function* () {
  const pageId = yield select(pageIdSelector);
  const country = yield select(countryCodeSelector);
  const language = yield select(languageCodeSelector);

  return yield call(
    getOptimizationLocations,
    DEFAULT_OPTIMIZATION_LOCATION_NAME,
    {
      appCountry: country?.toUpperCase(),
      appLanguage: language,
      appPageId: pageId,
    },
  );
};

export const applyVariationPatch = function* (variationId) {
  const state = yield select();
  const storePatch = state.storePatches[variationId];
  if (!storePatch) {
    return;
  }
  try {
    const patchedState = applyPatch(state, storePatch);
    yield put({ payload: patchedState, type: HYDRATE });
  } catch (err) {
    logger.warn({
      ...err,
      details: {
        variationId,
      },
      name: 'Failed to apply store patch',
    });
  }
};
